import { useRef, useState } from "react";
import { getISODay, getDaysInMonth } from "date-fns";

import style from "./style.module.scss";
import Dates from "./dates";
import { useWidth } from "../../../../hooks";
import { range } from "../../../../utils";

const days = ["D", "L", "M", "M", "J", "V", "S"];
const months = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
];

interface MonthProps {
  month: number;
  year: number;
  color: string | null;
  dates: Record<number, string>;
  onChange: (dates: Record<number, string>) => void;
  isPreview?: boolean;
}

function Month({ month, year, color, dates, onChange, isPreview }: MonthProps) {
  const firstDay = new Date(year, month, 1);
  const firstDayOffset = getISODay(firstDay) % 7;
  const maxDays = getDaysInMonth(firstDay);
  const inlineStyle = { backgroundColor: color ?? undefined };
  const ref = useRef<HTMLDivElement>(null);
  const width = useWidth(ref);
  const [isModalOpened, setModalOpened] = useState(false);

  return (
    <div
      ref={ref}
      className={style.container}
      style={{
        fontSize: `${width}px`,
      }}
    >
      {!isPreview && (
        <div className={style.dates}>
          <Dates
            month={month}
            year={year}
            dates={dates}
            onChange={onChange}
            isModalOpened={isModalOpened}
            setModalOpened={setModalOpened}
          />
        </div>
      )}
      <div className={style.border} style={inlineStyle} />
      <div className={style.title}>
        {months[month]} {year}
      </div>
      <div
        className={style.monthContainer}
        onClick={isPreview ? undefined : () => setModalOpened(true)}
      >
        {range(7).map((dayIndex) => (
          <div className={style.header} key={`header-${dayIndex}`}>
            {days[dayIndex]}
          </div>
        ))}
        {range(firstDayOffset).map((index) => (
          <div className={style.empty} key={`empty-${index}`} />
        ))}
        {range(maxDays).map((index) => (
          <div className={style.day} key={`day-${index}`}>
            <div className={style.dayBorder} style={inlineStyle} />
            {index + 1}
            {!!dates[index] && (
              <div style={{ color: color ?? undefined }} className={style.note}>
                {dates[index]}
              </div>
            )}
          </div>
        ))}
        {range(7 * 5 - (maxDays + firstDayOffset)).map((index) => (
          <div className={style.empty} key={`remaining-${index}`} />
        ))}
      </div>
    </div>
  );
}

export default Month;
